module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-700italic.e6e2be7a45e76c63f825a247fb98edba.woff2";